import { Element } from '../../../common/html/element'
import { PopupAction } from '../../../common/popup/PopupAction'

export const PopupDeleteCompany = ({
  isShow,
  setShow,
  onSubmit,
  renderContent,
}) => {
  return (
    <>
      {isShow && (
        <PopupAction
          isShow={isShow}
          title="library.main.REMOVE_FROM_PORT"
          handleClose={() => setShow(false)}
          btnSubmit={{
            label: 'library.main.REMOVE',
            isI18n: true,
            event: (e) => {
              e.stopPropagation()
              onSubmit()
            },
          }}
          btnCancel={{
            label: 'library.filterSetting.CANCEL',
            isI18n: true,
            event: (e) => {
              e.stopPropagation()
              setShow(false)
            },
          }}
        >
          <Element elementName="p" style={{ overflowWrap: 'break-word' }}>
            {renderContent && renderContent()}
          </Element>
        </PopupAction>
      )}
    </>
  )
}
